import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import HistoricalReturnsFull from './historical-returns-full';

const HistoricalReturnsFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <HistoricalReturnsFull {...props} />
    </QueryClientProvider>
  );
};

export { HistoricalReturnsFullWidget }
